import { render, staticRenderFns } from "./brandModal.vue?vue&type=template&id=76f14a67&"
import script from "./brandModal.vue?vue&type=script&lang=js&"
export * from "./brandModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports